module.exports = __webpack_public_path__ + "img/history.bc5b779e.svg";